

(function () {
  var btn = document.querySelector('[data-wc-header-checkout]');
  if (!btn) return;

  function paint(state) {
    if (!state) return;
    var show = (state.count || 0) >= 3;
    btn.style.display = show ? '' : 'none';
    btn.classList.remove('is-pulse', 'is-strong', 'is-locked');
    if (state.count >= 6)      btn.classList.add('is-locked');
    else if (state.count >= 5) btn.classList.add('is-strong');
    else if (state.count >= 4) btn.classList.add('is-pulse');
  }

  document.addEventListener('wc:tier-updated', function (e) { paint(e.detail); });

  if (window.WCTier && typeof window.WCTier.getState === 'function') {
    var s = window.WCTier.getState();
    if (s) paint(s);
  }
})();
